<template>
  <b-form-group :label="$t(label)"
                class="rangeInput">
    <div class="d-flex align-items-center justify-content-between">
      <b-form-input :id="id"
                    v-model="value"
                    :input="inputValue()"
                    :state="state"
                    :min="min"
                    :max="max"
                    :step="step"
                    type="range"
                    class="customRange"></b-form-input>
      <!-- step="0.5" -->
      <div class="val d-flex align-items-center justify-content-between">

        <b-form-input class="valueInput"
                      v-model="value"
                      @keypress="isNumber($event)"
                      @keyup="controlMinMax($event)"
                      :input="inputValue()"></b-form-input><span v-if="unit"
              class="mr-2">{{unit}}</span>
      </div>
    </div>
  </b-form-group>
</template>

<script>
export default {
  props: {
    label: String,
    id: String,
    state: Boolean,
    defaultValue: {
      type: Number | String,
      default: 0,
    },
    min: {
      type: Number | String,
      default: 0,
    },
    max: {
      type: Number | String,
      default: 100,
    },
    step: {
      type: Number | String,
      default: 1,
    },
    unit: String,
  },
  name: 'RangeSlider',
  data() {
    return {
      value: 0,
      customValue: 0,
    }
  },
  created() {
    this.setValue()
  },
  methods: {
    setValue() {
      this.value = this.defaultValue != 0 ? this.defaultValue : this.min
    },
    inputValue() {
      this.$emit('input', this.value)
    },
    inputCustomValue() {
      if (parseFloat(this.value) >= this.max) this.value = this.max
      else if (parseFloat(this.value) < this.min) this.value = this.min

      this.$emit('input', this.value)
    },
    isNumber(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    controlMinMax(evt) {
      if (parseFloat(this.value) >= this.max) this.value = this.max
      else if (parseFloat(this.value) < this.min) this.value = this.min
    },
  },
  watch: {
    min(val) {
      this.setValue()
    },
  },
}
</script>

<style scoped lang="scss">
.rangeInput {
  .val {
    height: calc(1.5em + 1.3rem + 2px);
    min-width: 70px;
    padding: 0.65rem 0.5rem;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #3f4254;
    background-color: #ffffff;
    background-clip: padding-box;
    border: 1px solid #e4e6ef;
    margin-left: 10px;
    span {
      color: #b5bbc6;
    }
  }
  .customRange {
    &::before {
      content: attr(min);
      font-size: 14px;
      line-height: 14px;
      padding-right: 5px;
    }
    &::after {
      content: attr(max);
      font-size: 14px;
      line-height: 14px;
      padding-left: 5px;
    }
    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      background: #3699ff;
      border: 1px solid #ffffff;
      box-sizing: border-box;
      border-radius: 100px;
      cursor: pointer;
      padding: 10px;
      margin-top: -7px;
    }
    &::-webkit-slider-runnable-track {
      background: rgba(54, 153, 255, 0.2);
      border-radius: 5px;
    }
    &:focus {
      outline: none;
    }
  }
  .valueInput {
    border: none;
    outline: none;
    padding: 0;
    margin: 0;
    width: 30px;
    height: auto;
    z-index: 9999;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #3f4254;
  }
}
</style>